import { Rocket, Github, Twitter, Menu, X } from 'lucide-react'
import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const location = useLocation()

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-gray-900/20 backdrop-blur-xl border-b border-cyan-500/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 animate-fade-in-up hover:scale-105 transition-transform duration-200">
            <div className="relative p-2 bg-gradient-to-br from-cyan-500/20 to-purple-600/20 backdrop-blur-xl rounded-2xl border border-cyan-500/30 shadow-lg">
              <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/10 to-purple-600/10 rounded-2xl animate-pulse-glow"></div>
              <Rocket className="w-6 h-6 text-cyan-400 relative z-10" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-white font-display neon-text">SiteGen</h1>
              <p className="text-xs text-cyan-300 hidden sm:block font-medium">Memecoin Site Generator</p>
            </div>
          </Link>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/generate" className={`relative transition-all duration-300 font-medium group ${location.pathname === '/generate' ? 'text-cyan-400' : 'text-gray-300 hover:text-cyan-400'}`}>
              Generator
              <span className={`absolute -bottom-1 left-0 h-0.5 bg-gradient-to-r from-cyan-400 to-blue-500 transition-all duration-300 ${location.pathname === '/generate' ? 'w-full' : 'w-0 group-hover:w-full'}`}></span>
            </Link>
            <Link to="/about" className={`relative transition-all duration-300 font-medium group ${location.pathname === '/about' ? 'text-cyan-400' : 'text-gray-300 hover:text-cyan-400'}`}>
              About
              <span className={`absolute -bottom-1 left-0 h-0.5 bg-gradient-to-r from-cyan-400 to-blue-500 transition-all duration-300 ${location.pathname === '/about' ? 'w-full' : 'w-0 group-hover:w-full'}`}></span>
            </Link>
          </nav>
          
          {/* Desktop Social Links */}
          <div className="hidden md:flex items-center space-x-3">
            <a 
              href="https://github.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="p-2 text-gray-400 hover:text-cyan-400 transition-all duration-300 rounded-xl hover:bg-cyan-500/10 hover:scale-110"
            >
              <Github className="w-5 h-5" />
            </a>
            <a 
              href="https://twitter.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="p-2 text-gray-400 hover:text-cyan-400 transition-all duration-300 rounded-xl hover:bg-cyan-500/10 hover:scale-110"
            >
              <Twitter className="w-5 h-5" />
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-expanded={isMobileMenuOpen}
            aria-label="Toggle menu"
            className={`md:hidden p-2 text-gray-400 hover:text-cyan-400 transition-all duration-300 rounded-xl hover:bg-cyan-500/10 ${isMobileMenuOpen ? 'bg-cyan-500/10' : ''}`}
          >
            <div className="relative w-5 h-5">
              <Menu className={`absolute inset-0 w-5 h-5 transition-all duration-300 ${isMobileMenuOpen ? 'opacity-0 scale-75 rotate-90' : 'opacity-100 scale-100 rotate-0'}`} />
              <X className={`absolute inset-0 w-5 h-5 transition-all duration-300 ${isMobileMenuOpen ? 'opacity-100 scale-100 rotate-0' : 'opacity-0 scale-75 -rotate-90'}`} />
            </div>
          </button>
        </div>

        {/* Mobile Menu */}
        <div className={`md:hidden overflow-hidden border-t border-cyan-500/20 bg-gray-900/40 backdrop-blur-xl rounded-b-2xl transition-all duration-300 ${isMobileMenuOpen ? 'max-h-[320px] opacity-100' : 'max-h-0 opacity-0'}`}>
          <nav className="px-4 py-6 space-y-4">
              <Link 
                to="/generate" 
                className="block text-gray-300 hover:text-cyan-400 transition-all duration-300 py-3 px-4 rounded-xl hover:bg-cyan-500/10 font-medium"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Generator
              </Link>
              <Link 
                to="/about" 
                className="block text-gray-300 hover:text-cyan-400 transition-all duration-300 py-3 px-4 rounded-xl hover:bg-cyan-500/10 font-medium"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                About
              </Link>
              <div className="flex items-center space-x-3 pt-4 border-t border-cyan-500/20">
                <a 
                  href="https://github.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="p-3 text-gray-400 hover:text-cyan-400 transition-all duration-300 rounded-xl hover:bg-cyan-500/10"
                >
                  <Github className="w-5 h-5" />
                </a>
                <a 
                  href="https://twitter.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="p-3 text-gray-400 hover:text-cyan-400 transition-all duration-300 rounded-xl hover:bg-cyan-500/10"
                >
                  <Twitter className="w-5 h-5" />
                </a>
              </div>
            </nav>
          </div>
      </div>
    </header>
  )
}

export default Header 